module.exports = __webpack_public_path__ + "static/media/logo-header_new.6b95aa7d.svg";